import React, { useState, useRef } from 'react';
import ZentorgaForm from '../components/ZentorgaForm';
import SoundVideo from '../components/SoundVideo';
import BenefitPeriod from '../../components/BenefitPeriod';
import { useFormSubmit } from '../hooks/useFormSubmit';
import '../styles/zentorga.scss';
import '../styles/template14.scss';

const Template14 = ({ landingData, urlCode, urlCodeSettingId, adNumber }) => {
  const { handleSubmit, isSubmitting } = useFormSubmit(
    urlCode,
    urlCodeSettingId,
    landingData.endpoint
  );
  const [selected, setSelected] = useState('');
  const formRef = useRef(null);

  const answerColor = landingData.surveyAnswer?.answerColor || '#020b46';
  const numberColor = landingData.surveyTopic?.numberColor || '#01A5FB';

  const answers = [
    landingData.surveyOpt1_1,
    landingData.surveyOpt1_2,
    landingData.surveyOpt1_3,
    landingData.surveyOpt1_4,
    landingData.surveyOpt1_5,
    landingData.surveyOpt1_6,
  ].filter(Boolean);

  const bgUrl = landingData.imgUrl1 || '';
  const bgExt = bgUrl.split('?')[0].split('.').pop().toLowerCase();
  const isBgVideo = ['mp4', 'webm', 'ogg', 'mov'].includes(bgExt);

  const handleFormSubmit = async (formData) => {
    await handleSubmit({
      ...formData,
      ...(selected && { selectedOption: selected }),
    });
  };

  return (
    <section className="template14-layout zentorga-layout">

      {/* 배경이미지 + 설문 오버레이 */}
      <div className="template14-bg">
        {isBgVideo ? (
          <div className="template14-video">
            <SoundVideo src={bgUrl} loop />
          </div>
        ) : (
          <img
            className="template14-img"
            src={landingData.imgUrl1 || ''}
            alt=""
          />
        )}
        <div className={`template14-content-wrapper ${['A914', 'A974', 'A975', 'A1015', 'A1061', 'A1064'].includes(adNumber) ? `ad-${adNumber}` : ''}`}>
          {landingData.surveyTitle1 && (
            <div className="area-question-box" style={{ '--answer-color': answerColor }}>
              <div className="title-box">
                <span className="question-number" style={{ color: numberColor }}>01</span>
                <h3 style={{ whiteSpace: 'pre-line' }}>{landingData.surveyTitle1}</h3>
              </div>
              <div className="area-options">
                {answers.map((answer, idx) => (
                  <button
                    key={idx}
                    type="button"
                    className={`option-btn ${selected === answer ? 'active' : ''}`}
                    onClick={() => setSelected(answer)}
                  >
                    {answer}
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* 하단 폼 영역 */}
      <div className="template14-bottom">

        {landingData.eventTarget && (
          <div className="eventTarget">
            <p>이벤트 대상자 : <span className="event-target-text">{landingData.eventTarget}</span></p>
          </div>
        )}

        {landingData.benefitDate && (
          <div className="benefitDate">
            <BenefitPeriod periodType={landingData.benefitDate} />
          </div>
        )}

        <div className="formStyleClassName">
          <ZentorgaForm
            ref={formRef}
            onSubmit={handleFormSubmit}
            isSubmitting={isSubmitting}
            formStyle={landingData.formStyleClassName || 'gray'}
            consentStyle={landingData.privacyPolicyClassName || 'dark'}
            privacyPolicyName={landingData.privacyPolicyName || '본원'}
            privacyPolicy={landingData.privacyPolicy}
            marketingPolicy={landingData.marketingPolicy}
            buttonComponent={
              <button
                type="button"
                className={`postBtn ${landingData.postBtnLocate === 'fixed' ? 'postBtn-fixed' : ''}`}
                id="postBtn"
                disabled={isSubmitting}
                onClick={() => {
                  if (landingData.postBtnLocate === 'fixed') {
                    window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
                  }
                  formRef.current?.submitForm();  // ← requestSubmit() 대신
                }}
              >
                {landingData.postBtnUrl ? (
                  <img src={landingData.postBtnUrl} alt="신청하기" />
                ) : (
                  <span>{isSubmitting ? '신청 중...' : '신청하기'}</span>
                )}
              </button>
            }
          />
        </div>

        {landingData.serviceInfoClassName && (
          <p
            className={`serviceInfoClassName ${landingData.serviceInfoClassName}`}
            id="serviceInfoClassName"
          >
            * 본 서비스는 전국 20여 개 이상의 제휴 병원에서 제공되며,<br />
            상담 신청 정보를 기반으로 전문 상담원이 적합한 제휴 병원을 안내해드립니다.
          </p>
        )}

        {landingData.footerClassName !== null &&
          (landingData.footerClassName !== undefined || landingData.footerDetail) && (
            <footer className={`footerClassName ${landingData.footerClassName || ''}`}>
              {landingData.footerDetail && (
                <p className="footerDetail" style={{ whiteSpace: 'pre-line' }}>
                  {landingData.footerDetail}
                </p>
              )}
            </footer>
          )}

      </div>
    </section>
  );
};

export default Template14;
